<!-- 
<app-smxquilleditor></app-smxquilleditor> -->

<div class="container-fluid d-flex flex-column">
    <app-common-header [isVisible]="false"></app-common-header>
    <div class="d-flex align-items-center m-b-10 justify-content-between">
      <div class="d-flex align-items-center">
        <div style="width: 200px">
        </div>
      </div>
      <div class="d-flex align-items-center templateBtn">
        <app-button
        class="ps-2"
        [buttonLable]="enumButtonName.ADD_CATEGORY"
        (click)="AddCategoryPopUp()"
        ></app-button> 

        <app-button
        class="ps-2"
        [buttonLable]="enumButtonName.TAG"
        (click)="TagPopup()"
        ></app-button> 
        
        <app-button
        class="ps-2"
        [buttonLable]="enumButtonName.NEW_TEMPLATE"
        (click)="openNewTemplate()"
        ></app-button>  
      </div>
    </div>
    <app-ag-grid class = "d-flex flex-column position-relative h-100 templateList"
      class=" d-flex flex-column position-relative h-100"
      [dataModel]="AgGridDataModelTemplate"
      [getRowStyle]="getRowStyle"
      (onDeleteIconClick)="onDeleteIconClick($event)"
      (onEditIconClick)="onEditIconClick($event)"
    ></app-ag-grid>
  </div>

